import {
  Container,
  Typography,
  Paper,
  Select,
  FormControl,
  MenuItem,
  Button,
  Box,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Modal,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UpdateExamCriteria = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [className, setClassName] = useState([]);
  const [examData, setExamData] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    classTypeId: "",
    examType: "",
    isExamModeIndependent: true,
    isExamWeightIndependent: true,
    minMarks: "",
    maxMarks: "",
  });

  const { examCriteriaId } = useParams();

  const fetchClassddl = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/ClassType/GetClassType`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const responseData = await response.json();

        if (responseData.status !== null) {
          setClassName(responseData);
        } else {
          console.error("No data found for classes");
        }

        if (responseData.msg && responseData.msg !== "Record Not Found") {
          console.error("API error:", responseData.msg);
        }
      } else {
        console.error("Failed to fetch class data");
      }
    } catch (error) {
      console.error("API request error:", error);
    }
  };

  const fetchExam = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/ExaminationCriteria/GetExaminationCriteria`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ examCategoryId: examCriteriaId }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data && data.length > 0) {
          const exam = data[0]; // Assuming you want the first exam entry
          setFormData({
            classTypeId: exam.classTypeId.toString(),
            examType: exam.examType,
            isExamModeIndependent: Boolean(exam.isExamModeIndependent),
            isExamWeightIndependent: Boolean(exam.isExamWeightIndependent),
            minMarks: exam.minNumber,
            maxMarks: exam.maxNumber,
          });
        }
      } else {
        console.error("Failed to fetch exam data");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value === "true",
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate required fields (classTypeId and examType)
    if (!formData.classTypeId || !formData.examType) {
      // alert('Please select Class Type and enter Exam Type.');
      setSnackbarMessage('Please select Class Type and enter Exam Type.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning")
      console.log('Validation failed: Missing classTypeId or examType');
      return;
    }

    // Validate minMarks and maxMarks only if isExamModeIndependent is true
    if (formData.isExamModeIndependent) {
      if (!formData.minMarks || !formData.maxMarks) {
        // alert('Please enter both Min Marks and Max Marks for Independent mode.');
        setSnackbarMessage('Please enter both Min Marks and Max Marks for Independent mode.');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning")
        console.log('Validation failed: Missing minMarks or maxMarks in Independent mode');
        return;
      }

      const minMarks = parseFloat(formData.minMarks);
      const maxMarks = parseFloat(formData.maxMarks);

      // Validate range (1 to 100)
      if (minMarks < 1 || minMarks > 100 || maxMarks < 1 || maxMarks > 100) {
        // alert('Min Marks and Max Marks must be between 1 and 100.');
        setSnackbarMessage('Min Marks and Max Marks must be between 1 and 100.');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning")
        console.log('Validation failed: Min/Max Marks out of range');
        return;
      }

      // Validate maxMarks > minMarks
      if (maxMarks <= minMarks) {
        // alert('Max Marks must be greater than Min Marks.');
        setSnackbarMessage('Max Marks must be greater than Min Marks.');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning")
        console.log('Validation failed: Max Marks <= Min Marks');
        return;
      }
    }

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');

      // Ensure API URL and token are available
      if (!apiUrl || !token) {
        // alert('API URL or token is missing.');
        setSnackbarMessage('API URL or token is missing.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
        return;
      }

      const payload = {
        ...formData,
        minMarks: formData.isExamModeIndependent ? parseFloat(formData.minMarks) || 0 : 0,
        maxMarks: formData.isExamModeIndependent ? parseFloat(formData.maxMarks) || 0 : 0
      };

      const response = await fetch(`${apiUrl}/ExaminationCriteria?ExamId=${examCriteriaId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      console.log('API response status:', response.status); // Log response status

      if (response.ok) {
        setShowSuccessModal(true);
        // alert('Data saved successfully');
        // navigate(-1); // Navigate to the specified page
      } else {
        let errorMessage = 'Failed to save data';
        try {
          const errorData = await response.text();
          errorMessage += `: ${errorData || response.statusText || 'Unknown error'}`;
          console.error('API error response:', errorData);
        } catch (textError) {
          console.error('Error reading response:', textError);
        }
        // alert(errorMessage);
        setSnackbarMessage(errorMessage);
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      }
    } catch (error) {
      // alert('API request error. Please check the console for details.');
      setSnackbarMessage('API request error. Please check the console for details.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      console.error('API request error:', error);
    }
  };

  const handleReset = () => {
    navigate(-1)
  };

  useEffect(() => {
    fetchClassddl();
    fetchExam();
  }, []);

  // Add a new handler for minMarks and maxMarks to restrict input to 1–100
  const handleMarksChange = (event) => {
    const { name, value } = event.target;
    // Allow empty input or valid numbers between 1 and 100
    if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 1 && parseInt(value) <= 100)) {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  return (

    <Container>
      <Box
        sx={{
          backgroundColor: '#0B1F3D', // dark navy blue
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Exam Category
        </Typography> </Box>
      <Paper elevation={3} style={{ padding: 20, marginBottom: 20 }}>


        <form className="row g-4" style={{ marginTop: 20 }} onSubmit={handleSubmit}>
          <div className="col-md-5">
            <FormControl fullWidth>
              <InputLabel htmlFor="classType">Class Type</InputLabel>
              <Select
                id="classType"
                name="classTypeId"
                label="Class Type"
                value={formData.classTypeId}
                onChange={handleChange}
              >
                <MenuItem value="">--Select--</MenuItem>
                {className.map((item) => (
                  <MenuItem key={item.classTypeId} value={item.classTypeId}>
                    {item.classType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-5">
            <TextField
              fullWidth
              label="Exam Type"
              name="examType"
              value={formData.examType}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <FormControl component="fieldset">
              <Typography variant="subtitle1">Exam Mode</Typography>
              <RadioGroup
                row
                value={formData.isExamModeIndependent.toString()}
                onChange={handleRadioChange}
                name="isExamModeIndependent"
              >
                <FormControlLabel value="true" control={<Radio />} label="Independent" />
                <FormControlLabel value="false" control={<Radio />} label="Subcategory" />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl component="fieldset">
              <Typography variant="subtitle1">Exam Weightage</Typography>
              <RadioGroup
                row
                value={formData.isExamWeightIndependent.toString()}
                onChange={handleRadioChange}
                name="isExamWeightIndependent"
              >
                <FormControlLabel value="true" control={<Radio />} label="Independent" />
                <FormControlLabel value="false" control={<Radio />} label="Weightage" />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="col-md-5">
            <TextField
              fullWidth
              label="Min Marks"
              name="minMarks"
              type="number"
              value={formData.minMarks}
              onChange={handleMarksChange}
              style={{ display: formData.isExamModeIndependent ? "block" : "none" }}
              required={formData.isExamModeIndependent}
              inputProps={{
                min: 1,
                max: 100,
                step: 1,
              }}
              onKeyDown={(e) => {
                if (['-', 'e', '+', '.'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="col-md-5">
            <TextField
              fullWidth
              label="Max Marks"
              name="maxMarks"
              type="number"
              value={formData.maxMarks}
              onChange={handleMarksChange}
              style={{ display: formData.isExamModeIndependent ? "block" : "none" }}
              required={formData.isExamModeIndependent}
              inputProps={{
                min: 1,
                max: 100,
                step: 1,
              }}
              onKeyDown={(e) => {
                if (['-', 'e', '+', '.'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Button variant="contained" color="primary" type="submit" style={{
              marginRight: 6, width: "80px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}>
              <b>update</b>
            </Button>
            <Button variant="contained" color="error" onClick={handleReset} type="reset" style={{
              width: "80px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}>
              <b>CANCEL</b>
            </Button>
          </div>
        </form>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Exam Category Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Exam Category is Updated successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>

  );
};

export default UpdateExamCriteria;
